import { defineComponent as _defineComponent } from 'vue'
import Irmao from 'common/types/Irmao'


export default /*#__PURE__*/_defineComponent({
  __name: 'CabecalhoDeDetalhesDoIrmao',
  props: {
    irmao: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})